<template>
  <div>
    <vs-table class="border-0 border-solid border-t border-silver-gray" ref="table"
      :max-items="tableData.results.length" v-if="tableData.results && tableData.results.length"
      :data="tableData.results || []">
      <template slot="thead">
        <vs-th v-for="(header, idx) in headers" :key="idx" class="text-black font-semibold text-sm">
          {{ header }}
        </vs-th>
      </template>
      <template v-if="tableData.results && tableData.results.length">
        <tbody>
          <vs-tr v-for="(tr, indextr) in tableData.results" :key="indextr"
            :class="[indextr % 2 === 0 ? 'bg-soft-gray' : '']">
            <vs-td>
              {{ tr.vehicle_id }}
            </vs-td>
            <vs-td>
              {{ tr.vin }}
            </vs-td>
            <vs-td>
              {{ tr.state }}
            </vs-td>
            <vs-td>
              {{ tr.miles }}
            </vs-td>
            <vs-td>
              {{ tr.month }}
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
export default {
  props: {
    tableData: {
      type: Object,
      required: true,
      default: () => ({
        results: []
      })
    }
  },
  data() {
    return {
      headers: ['Vehicle', 'VIN', 'State', 'Miles', 'Month']
    }
  }
};
</script>

<style scoped></style>
